module.exports = __webpack_public_path__ + "static/media/usecase1.45cfff65.png";